var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"fcs-radio"},[_vm._t("default"),_c('span',{staticClass:"checkbox large"},[_vm._v(_vm._s(_vm.buttonText))])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }